export const state = {
  pettyaccounts: [],
  systemPettyaccount: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettyaccounts/state.js